import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home as HomeIcon, ClipboardList } from 'lucide-react';

const BottomNav = () => {
  const base =
    'flex flex-col items-center gap-1 py-1 transition-colors duration-200';

  return (
    <nav
      className="flex items-start justify-around px-6 pt-3 pb-6"
      style={{
        borderTop: '1px solid rgba(255,255,255,0.10)',
        background: 'var(--lp-nav-bg)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <NavLink to="/" end className={base}>
        {({ isActive }) => (
          <>
            <HomeIcon
              size={22}
              strokeWidth={2}
              style={{ color: isActive ? 'var(--lp-cream)' : 'var(--lp-faint)' }}
            />
            <span
              className="text-[12px]"
              style={{
                color: isActive ? 'var(--lp-cream)' : 'var(--lp-faint)',
                fontWeight: isActive ? 600 : 500,
              }}
            >
              Home
            </span>
          </>
        )}
      </NavLink>

      <NavLink to="/memory" className={base}>
        {({ isActive }) => (
          <>
            <ClipboardList
              size={22}
              strokeWidth={2}
              style={{ color: isActive ? 'var(--lp-cream)' : 'var(--lp-faint)' }}
            />
            <span
              className="text-[12px]"
              style={{
                color: isActive ? 'var(--lp-cream)' : 'var(--lp-faint)',
                fontWeight: isActive ? 600 : 500,
              }}
            >
              Memory
            </span>
          </>
        )}
      </NavLink>
    </nav>
  );
};

export default BottomNav;
